import { combineReducers } from 'redux';
import shop from './shop';
import builder from './builder';

const rootReducer = combineReducers({
    shop,
    builder
});

export default rootReducer;